export default "__VITE_ASSET__CUVyB5Uk__"